import { render, staticRenderFns } from "./DataList.vue?vue&type=template&id=0a6684a5&"
import script from "./DataList.vue?vue&type=script&lang=ts&"
export * from "./DataList.vue?vue&type=script&lang=ts&"
import style0 from "./DataList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports